import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components';
import { rgba } from 'polished';
import { Link, withRouter } from 'react-router-dom'
import { findIndex, filter, find } from 'lodash';
import InfiniteScroll from 'react-infinite-scroller';

import { fetchChapters, getChapters } from './redux'

import { Chapter } from '../../components'

import { isClient } from '../../utils'
import { media } from '../../styles/utils';
import { green, greenSecondary } from '../../styles/colors';
import { hoverState, padding } from '../../styles/global';
import { data } from './data';

class Chapters extends Component {

    constructor(props) {
        super(props);
        this.scrollContainer = React.createRef();
    }

    state = {
        limit: 1,
        slug: '',
        section: ''
    }
    
    static fetchData(store, match) {
        return store.dispatch(fetchChapters()); 
    }

    componentWillMount = () => {
        const { params } = this.props.match

        // fetchChapters is run in Sidebar.js
        //this.props.fetchChapters()

        if (params) {
            this.setState({ 
                slug: params.slug,
                section: params.section
            })
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        const { location } = this.props;

        if (location.pathname !== prevProps.location.pathname) {
            const slug = this.props.match.params.slug;
            
            if (isClient()) {
                this.scrollContainer.current.scrollTo(0, 0)
            }
    
            if (slug) {
                this.setState({ 
                    slug: slug,
                    limit: 1 
                })
            }
        }
    }
    
    loadMore = () => {        
        this.setState({
            chapters: this.state.limit++
        })
    }

    getSection = (parentID) => {
        const { chapters } = this.props;
        const parent = find(chapters.data, {id: parentID});

        //console.log(parentID)

        if (parent) {
            return parent
        }
    }
        
    render() {
        const { limit, slug, section } = this.state;
        const { chapters } = this.props;

        // Find post by slug and every post after

        let chaptersArray;
        let self = this;

        if (chapters.data && slug) {

            //console.log('chapters.data',chapters.data);
            let hasPassed = false;
            
            chaptersArray = filter(chapters.data, function(chapter) { 
                const parent = self.getSection(chapter.parent_id)

                //console.log(parent,)

                // Exclude parent items 

                if (chapter.parent_id == 0) {
                    return false
                }

                if (hasPassed) { 
                    return true 
                } else if (chapter.slug == slug && parent.slug == section) {
                    hasPassed = true
                    return true
                }
            });
        }
       
        return (
            <Container
                innerRef={this.scrollContainer}
                id={'scroll-container'}
            >
                
                {chaptersArray && chapters.data && (
                    <InfiniteScroll
                        pageStart={0}
                        loadMore={this.loadMore}    
                        hasMore={limit < chaptersArray.length}
                        threshold={100}
                        useWindow={false}
                        style={{
                            width: '100%'
                        }}
                    >
                        {chaptersArray.slice(0, limit).map((chapter, i) => {
                            return (
                                <Chapter
                                    scrollIndex={i}
                                    data={chapter}
                                    scrollContainer={document.getElementById('scroll-container')}
                                />
                            )
                        })} 
                    </InfiniteScroll>
                )}

            </Container>
        )
    }
}

const Container = styled.div`
    display: flex;
    flex: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vh - 65px); 
`

const mapDispatchToProps = dispatch => ({

})

const mapStateToProps = (state, props) => ({
    chapters: getChapters(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Chapters));


// WEBPACK FOOTER //
// ./client/modules/Chapters/Chapters.js